var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _vm.orderModalData.open
        ? _c("sideBarOrderModal", {
            attrs: {
              modalData: _vm.orderModalData,
              onModalClose: _vm.closeModal,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.editBlackList.open
        ? _c("PhoneBlackListEditModal", {
            attrs: {
              newRecord: _vm.editBlackList.record,
              onCancel: _vm.closeBlackList,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-body" }, [
          _c(
            "form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.gerRecords.apply(null, arguments)
                },
              },
            },
            [
              _c("div", { staticClass: "range_picker flex" }, [
                _c(
                  "div",
                  { staticClass: "form-group mr-1" },
                  [
                    _c(
                      "label",
                      { staticClass: "d-block", attrs: { for: "" } },
                      [_vm._v("Период")]
                    ),
                    _vm._v(" "),
                    _c("date-range-picker", {
                      ref: "picker",
                      attrs: {
                        startDate: _vm.startDate,
                        opens: "right",
                        ranges: _vm.ranges,
                        "locale-data": _vm.date_locale,
                      },
                      model: {
                        value: _vm.dateRange,
                        callback: function ($$v) {
                          _vm.dateRange = $$v
                        },
                        expression: "dateRange",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group mr-1" },
                  [
                    _c(
                      "label",
                      { staticClass: "d-block", attrs: { for: "" } },
                      [_vm._v("Проект")]
                    ),
                    _vm._v(" "),
                    _c("CustomMultiSelect", {
                      ref: "selectedProjects",
                      attrs: {
                        records: Object.values(_vm.$AllProjects)
                          .filter((p) => p.is_active)
                          .map((p) => {
                            return { ...p, selectTitle: p.name }
                          }),
                        options: { placeholder: "Выберите проект" },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form-group mr-1" }, [
                  _c("label", { staticClass: "d-block", attrs: { for: "" } }, [
                    _vm._v("Тип заявок"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.searchFilter.order_type,
                          expression: "searchFilter.order_type",
                        },
                      ],
                      staticClass: "form-control",
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.searchFilter,
                            "order_type",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                      },
                    },
                    [
                      _c("option", { attrs: { value: "0" } }, [
                        _vm._v("Все заявки"),
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "1" } }, [
                        _vm._v("Курьерские"),
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "2" } }, [
                        _vm._v("Почтовые"),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group mr-2" }, [
                  _c("label", { attrs: { for: "" } }, [
                    _vm._v("Номер телефона"),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.phoneNum,
                        expression: "phoneNum",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { placeholder: "Номер телефона" },
                    domProps: { value: _vm.phoneNum },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.phoneNum = $event.target.value
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group mr-1 flex flex-column" }, [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.searchFilter.status,
                          expression: "searchFilter.status",
                        },
                      ],
                      attrs: { value: "0", type: "radio" },
                      domProps: {
                        checked: _vm._q(_vm.searchFilter.status, "0"),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$set(_vm.searchFilter, "status", "0")
                        },
                      },
                    }),
                    _vm._v(" Все статусы"),
                  ]),
                  _vm._v(" "),
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.searchFilter.status,
                          expression: "searchFilter.status",
                        },
                      ],
                      attrs: { value: "1", type: "radio" },
                      domProps: {
                        checked: _vm._q(_vm.searchFilter.status, "1"),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$set(_vm.searchFilter, "status", "1")
                        },
                      },
                    }),
                    _vm._v(" Только доставленые"),
                  ]),
                  _vm._v(" "),
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.searchFilter.status,
                          expression: "searchFilter.status",
                        },
                      ],
                      attrs: { value: "2", type: "radio" },
                      domProps: {
                        checked: _vm._q(_vm.searchFilter.status, "2"),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$set(_vm.searchFilter, "status", "2")
                        },
                      },
                    }),
                    _vm._v(" Только отмененные"),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-right" },
                [
                  _c("LoadingButton", {
                    attrs: {
                      title: "Показать",
                      className: "btn btn-success btn-xs",
                      type: "submit",
                      onClick: () => {},
                      loading: _vm.loading,
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("pulse-loader", {
        staticClass: "text-center",
        attrs: { loading: _vm.loading, color: _vm.loadingColor },
      }),
      _vm._v(" "),
      !_vm.loading
        ? _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-body" }, [
              _vm.paginator
                ? _c("div", { staticClass: "text-right" }, [
                    _c("p", [
                      _vm._v("Всего записей "),
                      _c("strong", [_vm._v(_vm._s(_vm.paginator.total))]),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("table", { staticClass: "table table-sm table-hover" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.records, function (record, index) {
                    return _c("tr", [
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            index +
                              1 +
                              (_vm.paginator.current_page !== 1
                                ? _vm.paginator.current_page *
                                    _vm.paginator.per_page -
                                  _vm.paginator.per_page
                                : 0)
                          ) + "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          record.type_id === 1
                            ? [
                                _c("i", {
                                  staticClass:
                                    "icon-fa icon-fa-arrow-left green",
                                }),
                              ]
                            : [
                                _c("i", {
                                  staticClass:
                                    "icon-fa icon-fa-arrow-right blue",
                                }),
                              ],
                          _vm._v(" "),
                          _c("p", { staticClass: "text-muted fs-10" }, [
                            _vm._v(_vm._s(record.id)),
                          ]),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("td", [
                        _c("p", [
                          _c(
                            "span",
                            {
                              class: {
                                active: record.phone_title === _vm.searchPhone,
                              },
                            },
                            [_vm._v(_vm._s(record.phone_title))]
                          ),
                        ]),
                        _vm._v(" "),
                        record.type_id === 1 && !record.call_duration
                          ? _c("p", { staticClass: "badge badge-warning" }, [
                              _vm._v("пропущенный вызов"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        record.type_id === 2 && _vm.lines[record.phone_title]
                          ? _c("p", { staticClass: "badge badge-info" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.lines[record.phone_title].description
                                  ) +
                                  "\n            "
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("p", [
                          _c(
                            "span",
                            {
                              class: {
                                active: record.destination === _vm.searchPhone,
                              },
                            },
                            [_vm._v(_vm._s(record.destination))]
                          ),
                        ]),
                        _vm._v(" "),
                        record.type_id === 1 && _vm.lines[record.destination]
                          ? _c("p", { staticClass: "badge badge-info" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.lines[record.destination].description
                                  ) +
                                  "\n              "
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.users[record.user_id] || "не определен"
                              ) +
                              "\n            "
                          ),
                          record.call_duration
                            ? [
                                _c("p", [
                                  _c("strong", [
                                    _vm._v(_vm._s(record.call_duration)),
                                  ]),
                                  _vm._v(" секунд"),
                                ]),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          record.client
                            ? [
                                _c("p", [_vm._v(_vm._s(record.client.name))]),
                                _vm._v(" "),
                                record.client.email
                                  ? _c("p", [
                                      _vm._v(_vm._s(record.client.email)),
                                    ])
                                  : _vm._e(),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          record.order
                            ? [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(record.order.id) +
                                    "\n              "
                                ),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-xs btn-info newWindowBtn mr-1",
                                    on: {
                                      click: function ($event) {
                                        return _vm.openOrderInModal(
                                          record.order.id
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "icon-fa icon-fa-eye",
                                    }),
                                  ]
                                ),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.blackList[record.id]
                            ? [
                                _c(
                                  "button",
                                  {
                                    class: {
                                      "btn btn-xs pointer": true,
                                      "btn-danger":
                                        _vm.blackList[record.id].is_active,
                                      "btn-dark":
                                        !_vm.blackList[record.id].is_active,
                                    },
                                    on: {
                                      click: () => {
                                        _vm.editBlackList = {
                                          open: true,
                                          record: _vm.blackList[record.id],
                                        }
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.blackList[record.id].is_active
                                            ? "черный"
                                            : "серый"
                                        ) +
                                        " список\n              "
                                    ),
                                  ]
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          record.file_link
                            ? [
                                !_vm.showFileRecord[record.id]
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-outline-info btn-xs",
                                        on: {
                                          click: function ($event) {
                                            return _vm.showRecord(record.id)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "Показать запись\n              "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.showFileRecord[record.id]
                                  ? [
                                      record.file_link
                                        ? _c(
                                            "audio",
                                            { attrs: { controls: "" } },
                                            [
                                              _c("source", {
                                                attrs: {
                                                  src: `https://admin.rancond.info/api/noa/mangoRecord/${record.id}`,
                                                  type: "audio/mpeg",
                                                },
                                              }),
                                              _vm._v(
                                                "\n                  Your browser does not support the audio tag.\n                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  : _vm._e(),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.printDate(
                                  record.created_at,
                                  "DD.MM.YYYY HH:mm"
                                )
                              )
                            ),
                          ]),
                        ],
                        2
                      ),
                    ])
                  }),
                  0
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pull-right" },
                [
                  _vm.paginator
                    ? _c("paginate", {
                        attrs: {
                          "page-count": _vm.paginator.last_page,
                          "page-range": 3,
                          "margin-pages": 2,
                          "click-handler": _vm.gerRecords,
                          "prev-text": "&laquo",
                          "next-text": "&raquo",
                          "container-class": "pagination",
                          "prev-class": "page-item",
                          "prev-link-class": "page-link",
                          "page-class": "page-item",
                          "page-link-class": "page-link",
                          "next-class": "page-item",
                          "next-link-class": "page-link",
                          "active-class": "active green_btn",
                        },
                        model: {
                          value: _vm.paginator.current_page,
                          callback: function ($$v) {
                            _vm.$set(_vm.paginator, "current_page", $$v)
                          },
                          expression: "paginator.current_page",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("№")]),
        _vm._v(" "),
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("с номера")]),
        _vm._v(" "),
        _c("th", [_vm._v("на номер")]),
        _vm._v(" "),
        _c("th", [_vm._v("Пользователь")]),
        _vm._v(" "),
        _c("th", [_vm._v("Клиент")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }